<div class="accordion-panel" [class.expanded]="expanded()">
  <div class="panel-header" contenteditable="false" [attr.aria-expanded]="expanded()">
    @if (isEditable()) {
      <span
        class="panel-icon"
        [class.panel-icon--with-bg]="parsedIcon()?.showBackground"
        [style.background-color]="iconBgColor()"
        [matMenuTriggerFor]="iconPickerMenu"
        (click)="$event.stopPropagation()"
        dojoStopPropagation
        title="Choose icon"
      >
        @if (parsedIcon(); as pi) {
          @switch (pi.type) {
            @case ('emoji') {
              {{ pi.value }}
            }
            @case ('fa') {
              <i [class]="'fas fa-' + pi.value" [style.color]="pi.color" style="font-size: 16px"></i>
            }
            @case ('img') {
              <img [src]="pi.value" alt="" class="panel-icon-img" />
            }
          }
        } @else {
          <span class="panel-icon-placeholder">+</span>
        }
      </span>
      <mat-menu #iconPickerMenu="matMenu" class="icon-picker-panel-menu">
        <div (click)="$event.stopPropagation()" dojoStopPropagation>
          <dojo-icon-picker-wrapper
            (iconSelected)="selectIcon($event)"
            [initialTab]="initialPickerTab()"
            [initialFaColor]="initialPickerFaColor()"
            [initialShowBackground]="initialPickerShowBg()"
            [activeIconValue]="activeIconValue()"
          />
          @if (parsedIcon()) {
            <button type="button" class="remove-icon-btn" (click)="removeIcon()">Remove icon</button>
          }
        </div>
      </mat-menu>
    } @else {
      @if (parsedIcon(); as pi) {
        <span
          class="panel-icon panel-icon--readonly"
          [class.panel-icon--with-bg]="pi.showBackground"
          [style.background-color]="iconBgColor()"
        >
          @switch (pi.type) {
            @case ('emoji') {
              {{ pi.value }}
            }
            @case ('fa') {
              <i [class]="'fas fa-' + pi.value" [style.color]="pi.color" style="font-size: 16px"></i>
            }
            @case ('img') {
              <img [src]="pi.value" alt="" class="panel-icon-img" />
            }
          }
        </span>
      }
    }

    <span
      #titleElement
      class="panel-title"
      [attr.contenteditable]="isEditable()"
      (input)="updateTitle($event)"
      (keydown.enter)="$event.preventDefault()"
      (click)="$event.stopPropagation()"
      dojoStopPropagation
    ></span>

    <div class="panel-header-right" (click)="$event.stopPropagation()">
      @if (isEditable()) {
        <div class="panel-actions">
          <button type="button" class="panel-action-btn" (click)="movePanelUp()" dojoStopPropagation title="Move up">
            <dojo-icon icon="chevron-up" [size]="12" />
          </button>
          <button
            type="button"
            class="panel-action-btn"
            (click)="movePanelDown()"
            dojoStopPropagation
            title="Move down"
          >
            <dojo-icon icon="chevron-down" [size]="12" />
          </button>
          <button
            type="button"
            class="panel-action-btn panel-action-btn--danger"
            (click)="removePanel()"
            dojoStopPropagation
            title="Remove panel"
          >
            <dojo-icon icon="trash" [size]="12" />
          </button>
        </div>
      }
      <span class="panel-chevron" [class.expanded]="expanded()" (click)="toggleExpanded()"></span>
    </div>
  </div>

  <div class="panel-content" [class.collapsed]="!expanded()">
    <div tiptapNodeViewContent></div>
  </div>
</div>
